import type { CsvCell } from '../ui/csv';
import type { Store } from '../data/types';

/**
 * The CSV "Owner" column (owner ruling 2026-10-28: reports by owner). A
 * builder given `ownerOf` adds the store's owner as the LAST column of each
 * row (blank on district / All rows); without it the CSV is unchanged — so
 * store teams, who never see owners, get the old file.
 */
export type OwnerOf = (store: Pick<Store, 'ownerId'>) => string;

export function withOwnerHeader(header: readonly string[], ownerOf: OwnerOf | null | undefined): string[] {
  return ownerOf ? [...header, 'Owner'] : [...header];
}

export function withOwnerCell(cells: CsvCell[], store: Pick<Store, 'ownerId'> | undefined, ownerOf: OwnerOf | null | undefined): CsvCell[] {
  if (!ownerOf) return cells;
  return [...cells, store ? ownerOf(store) : ''];
}
